exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/core-js/modules/_wks-ext.js
// module id = 198
// module chunks = 2 3 4 5 6 7 8 9 10 11 12